var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5189_3366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1724 10.0282H21.188V9.55948C21.188 6.58292 18.7739 4.16885 15.7974 4.16885C12.8208 4.16885 10.4067 6.58292 10.4067 9.55948V10.0282H6.42236C5.90381 10.0282 5.48486 10.4472 5.48486 10.9657V26.6689C5.48486 27.1874 5.90381 27.6064 6.42236 27.6064H25.1724C25.6909 27.6064 26.1099 27.1874 26.1099 26.6689V10.9657C26.1099 10.4472 25.6909 10.0282 25.1724 10.0282ZM19.0786 10.0282H12.5161V9.55948C12.5161 7.746 13.9839 6.27823 15.7974 6.27823C17.6108 6.27823 19.0786 7.746 19.0786 9.55948V10.0282Z",
    fill: "#F0F0F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5189_3366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9297,
    height: 30.9297,
    fill: "white",
    transform: "translate(0.0351562 0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyNow);
export default __webpack_public_path__ + "static/media/buy-now.fc5cd2813b2374742f7f5290550c3ffc.svg";
export { ForwardRef as ReactComponent };